import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { defaultStaleTime, queryKeys } from '@/lib/react-query';
import { PaginatedCustomersDto } from '@/models';
import { CustomersControllerFindAllWithPaginationV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toPaginatedCustomers } from '@/services/customer.service';

function getCustomersPaginated(params: CustomersControllerFindAllWithPaginationV1Params) {
  return getSMPBackendAPIAdmin().customersControllerFindAllWithPaginationV1(
    params
  ) as Promise<PaginatedCustomersDto>;
}

export function useCustomersPaginated(params: CustomersControllerFindAllWithPaginationV1Params) {
  return useQuery({
    queryKey: queryKeys.customers.pagination(params),
    queryFn: () => getCustomersPaginated(params),
    select: (data) => toPaginatedCustomers(data),
    placeholderData: keepPreviousData,
    staleTime: defaultStaleTime,
  });
}
